<template>
  <div class="h-screen">
    <div class="h-full lg:px-4 xl:px-4 pb-3 pt-5 overflow-auto bg-primary">
      <div class="h-full flex flex-col">
        <div
          class="flex mb-5"
          :class="[isExpanded ? 'justify-between' : 'justify-center']"
        >
          <img
            v-show="isExpanded"
            src="../../assets/shipo-itm-white-logo.png"
            class="w-2/5 pl-4"
          >
          <vs-icon
            color="#fff"
            class="w-8 rounded-lg bg-transparent cursor-pointer mt-5"
            :class="[isExpanded ? 'toggle-button-expand' : 'toggle-button-shrink']"
            :icon="isExpanded ? 'menu' : 'menu'"
            @click="toggleMenu"
          />
        </div>
        <div class="overflow-y-auto no-scrollbar">
          <div
            v-for="(item, index) of menuWithPermission"
            class="flex flex-col my-6 cursor-pointer"
            :class="isExpanded ? 'pl-4' : 'pl-0'"
            :key="index"
          >
            <vs-row
              vs-w="12"
              class="w-full flex flex-row items-center"
              :class="{'active-menu-container rounded-lg': isRouteActive(item)}"
            >
              <vs-col
                class="flex flex-col"
                :vs-w="isExpanded ? 2 : 12"
              >
                <img
                  class="w-8 self-center"
                  :class="`${item.isIconFilterWhite ? 'filter-white' : ''}`"
                  :src="item.icon"
                  @click="handleMenuClick(item)"
                >
              </vs-col>
              <vs-col
                v-if="isExpanded"
                class="pl-5 pr-3"
                :vs-w="isExpanded ? 8 : 0"
              >
                <p
                  class="flex-grow self-center text-white text-lg"
                  @click="handleMenuClick(item)"
                >
                  {{ truncateMenuName(item.name) }}
                </p>
              </vs-col>
              <vs-col
                v-if="isExpanded"
                :vs-w="isExpanded ? 2 : 0"
                class="flex flex-row items-center justify-end"
              >
                <vs-icon
                  v-if="item.children.length"
                  color="white"
                  class="self-center"
                  :icon="item.isExpand ? 'arrow_drop_up' : 'arrow_drop_down'"
                  @click="item.isExpand = !item.isExpand"
                />
              </vs-col>
            </vs-row>
            <div
              v-if="isExpanded && (item.children.length && item.isExpand)"
              class="mt-2 flex flex-col"
            >
              <div
                v-for="(child, childIndex) of item.children"
                :class="`flex w-full p-0 flex-col cursor-pointer ${childIndex === 0 ? 'rounded-tl-md rounded-tr-md' : ''} ${childIndex === item.children.length - 1 ? 'rounded-bl-md rounded-br-md' : ''} ${isRouteActive(child) ? 'active-menu-container' : 'bg-white'}`"
                :key="childIndex"
                @click="handleChildClick(child)"
              >
                <vs-row
                  vs-w="12"
                  :class="{'pr-6': !child.children}"
                >
                  <vs-col
                    class="px-2"
                    :vs-w="child.children ? 10 : 12"
                    :class="{'flex flex-col justify-center': child.children}"
                  >
                    <p
                      class="ml-12 font-semibold py-5"
                      :class="[isRouteActive(child) ? 'text-white' : 'text-primary', {'self-center': !child.children}]"
                    >
                      {{ child.name }}
                    </p>
                  </vs-col>
                  <vs-col
                    v-if="child.children && child.children.length"
                    vs-w="2"
                    class="flex flex-row px-1 items-center justify-end"
                  >
                    <vs-icon
                      color="primary"
                      class="self-center"
                      :icon="child.isExpand ? 'arrow_drop_up' : 'arrow_drop_down'"
                      :class="{'text-white': isRouteActive(child)}"
                    />
                  </vs-col>
                </vs-row>
                <div
                  v-if="child.children && child.children.length && child.isExpand"
                  class="flex flex-col"
                >
                  <div
                    v-for="(grandChild, grandChildIndex) of child.children"
                    :class="`w-full py-3 px-6 ${isUserCanAccessMenu(item.name, 'view') ? 'flex': 'hidden'} flex-row cursor-pointer ${isRouteActive(grandChild) ? 'active-menu-container' : 'bg-white'}`"
                    :key="grandChildIndex"
                    @click.stop="handleChildClick(grandChild)"
                  >
                    <p
                      class="font-semibold ml-16"
                      :class="[isRouteActive(grandChild) ? 'text-white' : 'text-primary']"
                    >
                      {{ grandChild.name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { APP_NAME } from '@/fixtures/Constants'
import store from '@/store'
import {
  isUserCanAccessMenu
} from '@/utils/permissionUtils'

export default {
  computed: {
    ...mapGetters({
      profile: 'Auth/me',
      menuIcons: 'Auth/menuIcons'
    })
  },
  watch: {
    profile: {
      deep: true,
      immediate: true,
      handler(val) {
        this.menu = val.permissions.filter(item => !item.is_permission_only)
        this.populateMenu()
      }
    },
    menuIcons: {
      deep: true,
      handler(val) {
        this.populateMenu()
      }
    }
  },
  data() {
    return {
      menu: store.getters['Auth/me'] && store.getters['Auth/me'].permissions ? store.getters['Auth/me'].permissions.filter(item => !item.is_permission_only) : [],
      isExpanded: true,
      menuWithPermission: []
    }
  },
  mounted() {
    this.populateMenu()
  },
  created() {
    this.$store.dispatch('Auth/hydrateMenuIcons')
  },
  beforeDestroy() {
    Object.values(this.menuIcons).forEach(url => {
      URL.revokeObjectURL(url)
    })
  },
  methods: {
    populateExpandMenu(item) {
      return this.menuWithPermission.find(mp => mp.id === item.id || mp.children.find(ch => ch.id === item.id || ch.hasOwnProperty('children') && ch.children.find(grand => grand.id === item.id)))?.isExpand
    },
    populateMenu() {
      this.menuWithPermission = this.menu
        .filter((item) => item.app_name === APP_NAME && isUserCanAccessMenu(item.name, 'view'))
        .map((item) => ({
          ...item,
          iconActive: item.icon && typeof item.icon === 'object' ? this.menuIcons[`${item.id}`]?.src || item.icon.downloadUrl : '',
          icon: item.icon && typeof item.icon === 'object' ? this.menuIcons[`${item.id}`]?.src || item.icon.downloadUrl : '',
          isIconFilterWhite: item.icon && this.menuIcons[`${item.id}`]?.type?.includes('svg') ? true : false,
          isExpand: this.populateExpandMenu(item) || false,
          children: item.children.filter(
            (child) => !child.is_permission_only && isUserCanAccessMenu(child.name, 'view')
          ).map((child) => ({
            ...child,
            parentId: item.id,
            isExpand: this.populateExpandMenu(child) || false,
            children: child.children?.filter((grandChild) => !grandChild.is_permission_only &&  isUserCanAccessMenu(grandChild.name, 'view'))
          }))
        }))
    },
    async updatePermissions() {
      try {
        await this.$store.dispatch('Auth/updatePermissions')
      } catch (error) {
        const message =
          error?.response?.data?.error?.message ||
          error?.data?.error?.message ||
          error?.message ||
        'Failed to save menu configuration, please try again'
        this.showFailedNotification(this, message)
      }
    },
    isRouteActive(child) {
      if (child.hasOwnProperty('children') && child.children.length) {
        let routeName = this.$route.name
        if(this.$route.meta.parent) routeName = this.$route.meta.parent.name
        const founded =  child.children.find(ch => {
          if(ch.url_name === routeName) return true
          if(ch.children && ch.children.length) return this.isRouteActive(ch)
        })
        return !!founded
      }

      return this.$route.meta.parent
        ? this.$route.meta.parent.name === child.url_name
        : this.$route.name === child.url_name
    },
    truncateMenuName(name) {
      // `12` is max string length for ellipsis for SD res
      if (window.matchMedia('(max-width: 1024px)').matches) {
        return name.length > 12 ? `${name.substring(0, 12)}...` : name
      }
      // `25` is max string length for ellipsis
      return name.length > 25 ? `${name.substring(0, 25)}...` : name
    },
    toggleMenu() {
      this.isExpanded = !this.isExpanded
      this.$emit('toggle', this.isExpanded)
    },
    async resolveUrl(name) {
      const isUrlExist = this.$router.resolve({ name })
      await this.$router.push({ name: isUrlExist.resolved.matched.length > 0 ? name : 'NotFound' })
      await this.updatePermissions();
    },
    async pushChildRouter(child) {
      if (!child.hasOwnProperty('children') || !child.children.length) {
        await this.$router.push({ name: child.url_name })
        await this.updatePermissions();
      }
    },
    handleChildClick(child) {
      if (child.hasOwnProperty('children') && child.children.length) {
        child.isExpand = !child.isExpand
      } else {
        this.pushChildRouter(child)
      }
    },
    handleMenuClick(item) {
      if (this.isExpanded) {
        if (item.children && item.children.length) {
          item.isExpand = !item.isExpand;
        } else {
          this.resolveUrl(item.url_name);
        }
      } else {
        this.resolveUrl(item.url_name);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.material-icons {
  font-size: 1.5rem !important;
}

.bg-purple {
  background-color: #6546C3;
}

.active-menu-container {
  background-color: #836ADA;
  padding: 0.25rem;
}


.tick-filled {
  height: 1rem;
  width: 1rem;
  background-color: #FF7F57;
  border-radius: 50%;
}

.tick-unfilled {
  height: 1rem;
  width: 1rem;
  background-color: #FFF;
  border-radius: 50%;
  border: 2px solid #ff7f57;
}

.toggle-button-expand {
  top: 2.5rem;
  left: calc(20% - 0.75rem);
}

.toggle-button-shrink {
  top: 2.5rem;
  left: calc(8.35% - 0.75rem);
}

.filter-white {
  filter: brightness(0) invert(1);
}

/* Hide scrollbar but keep scroll functionality */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
